import React from "react";
import { statusBadgeClass } from "./isfMilestoneService";

const formatVersionDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const MilestoneUsagePanel = ({ form = {} }) => (
  <div className="milestone-detail-sidebar__card milestone-detail-sidebar__card--usage">
    <h6 className="milestone-panel-title">Usage</h6>
    <dl className="milestone-detail-sidebar__stats">
      <div>
        <dt>Used in plans</dt>
        <dd>{form.UsedInPlans ?? 0}</dd>
      </div>
      <div>
        <dt>Used on templates</dt>
        <dd>{form.UsedOnTemplates ?? 0}</dd>
      </div>
      <div>
        <dt>Used in study eISF</dt>
        <dd>{form.UsedInStudies ?? 0}</dd>
      </div>
    </dl>
  </div>
);

export const MilestoneVersionHistoryPanel = ({
  form = {},
  versionHistory = [],
  onNavigateVersion,
}) => {
  const versions = versionHistory.length
    ? versionHistory
    : [
        {
          MilestoneId: form.MilestoneId,
          VersionNo: form.Version,
          Status: form.Status,
          SystemDateTime: form.SystemDateTime,
        },
      ];

  return (
    <div className="milestone-version-history-panel">
      <h6 className="milestone-panel-title">Version history</h6>
      <ul className="milestone-detail-sidebar__versions milestone-version-history-panel__list">
        {versions.map((row) => {
          const isCurrent =
            String(row.MilestoneId) === String(form.MilestoneId);
          return (
            <li
              key={row.MilestoneId}
              className={`milestone-detail-sidebar__version${isCurrent ? " milestone-detail-sidebar__version--current" : ""}`}
            >
              <button
                type="button"
                className="milestone-detail-sidebar__version-link"
                onClick={() => {
                  if (!isCurrent) onNavigateVersion?.(row.MilestoneId);
                }}
              >
                <div className="milestone-detail-sidebar__version-head">
                  <strong>v{row.VersionNo || "1.0"}</strong>
                  {isCurrent ? (
                    <span className="text-muted small">viewing</span>
                  ) : null}
                </div>
                <div className="milestone-detail-sidebar__version-meta">
                  <span className={statusBadgeClass(row.Status)}>
                    {row.Status}
                  </span>
                  <span className="text-muted small">
                    {formatVersionDate(row.SystemDateTime)}
                  </span>
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const MilestoneUsageVersionPanel = (props) => (
  <div className="milestone-detail-meta-panel">
    <div className="milestone-detail-meta-grid">
      <MilestoneUsagePanel form={props.form} />
      <MilestoneVersionHistoryPanel {...props} />
    </div>
  </div>
);

export default MilestoneUsageVersionPanel;
